// extracted by mini-css-extract-plugin
export default {"heading_container":"HeadingWithGrid_heading_container__9NFMg","heading":"HeadingWithGrid_heading__N1LhC"};